<template></template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'DataUpdater',

    methods: {
        updateData() {
            console.log('updateData', this.activePage)
            if (this.activePage === 'ten') this.$root.$refs.tenTable.getItems()
            else if (this.activePage === 'vat')
                this.$root.$refs.vatTable.getItems()
            else if (this.activePage === 'iss')
                this.$root.$refs.issTable.getItems()
            else if (this.activePage === 'dir')
                this.$root.$refs.dirTable.getItems()
            else if (this.activePage === 'bil')
                this.$root.$refs.bilTable.getItems()
            else if (this.activePage === 'sit')
                this.$root.$refs.sitTable.getItems()
            else if (this.activePage === 'prp')
                this.$root.$refs.prpTable.getItems()
            else if (this.activePage === 'oth')
                this.$root.$refs.otherTaxTable.getItems()
            else if (
                ['cfe', 'cva', 'das', 'dsi', 'tvs', 'tss'].includes(
                    this.activePage
                )
            )
                this.$root.$refs.otherTaxTable.getItems()
            else if (this.activePage === 'otm')
                this.$root.$refs.otherMissionsTable.getItems()
            else if (
                ['ecf'].includes(this.activePage)
            )
                this.$root.$refs.otherMissionsTable.getItems()
            else if (this.activePage === 'deadlinesToGenerate')
                this.$root.$refs.deadlinesToGenerate.getItems()
            else if (this.activePage === 'chargeGraph')
                this.$root.$refs.chargeChart.getChartData()
            else if (this.activePage === 'chargeTableGlobal')
                this.$root.$refs.chargeTableGlobal.getItems()
            else if (this.activePage === 'chargeTableCollaborator')
                this.$root.$refs.chargeTableCollaborator.getItems()
            else if (this.activePage === 'pivotChargeCollaborator')
                this.$root.$refs.pivotChargeCollaborator.updateData()
            else if (this.activePage === 'pivotChargeClient')
                this.$root.$refs.pivotChargeClient.updateData()
            else if (this.activePage === 'deadlines')
                this.$root.$refs.deadlines.getItems()
            else if (this.activePage === 'ownTasks')
                this.$root.$refs.ownTasksTable.getItems()
            else if (this.activePage === 'ownDelegatedTasks')
                this.$root.$refs.ownDelegatedTasksTable.getItems()
            else if (this.activePage === 'othersTasks')
                this.$root.$refs.othersTasksTable.getItems()
            else if (this.activePage === 'othersDelegatedTasks')
                this.$root.$refs.othersDelegatedTasksTable.getItems()
            else if (this.activePage === 'history.index')
                this.$root.$refs.historyIndex.getItems()
            else if (this.activePage === 'tasks.index')
                this.$root.$refs.tasksIndex.getItems()
            else if (this.activePage === 'billableTasks')
                this.$root.$refs.billableTasksTable.getItems()
            else if (this.activePage === 'billedTasks')
                this.$root.$refs.billedTasksTable.getItems()
            else if (this.activePage === 'plannedTasks')
                this.$root.$refs.plannedTasks.getItems()
            else if (this.activePage === 'clients')
                this.$root.$refs.clientsTable.getItems()
            else if (this.activePage === 'clientDeadlines')
                this.$root.$refs.clientDeadlinesTable.getItems()
            else if (this.activePage === 'pendingImported')
                this.$root.$refs.pendingImportedTable.getItems()
            else if (this.activePage === 'cac')
                this.$root.$refs.cacTable.getItems()
            else if (
                this.activePage === 'accountingFirmUserTimeSheetWeekReport'
            )
                this.$root.$refs.accountingFirmUserTimeSheetWeekReport.getItems()
            else if (
                this.activePage === 'accountingFirmUserTimeSheetYearReport'
            )
                this.$root.$refs.accountingFirmUserTimeSheetYearReport.getItems()
            else if (this.activePage === 'accountingFirmTimeSheetWeekReport')
                this.$root.$refs.accountingFirmTimeSheetWeekReport.getItems()
            else if (
                this.activePage === 'accountingFirmTimeSheetWeekChargeControl'
            )
                this.$root.$refs.accountingFirmTimeSheetWeekChargeControl.getItems()
            else if (this.activePage === 'accountingFirmTimeSheetYearReport')
                this.$root.$refs.accountingFirmTimeSheetYearReport.getItems()
            else if (this.activePage === 'balance-global')
                this.$root.$refs.dashboardBalanceGlobal.getData()
            else if (this.activePage === 'balance-user')
                this.$root.$refs.dashboardBalanceUser.getData()
            else if (this.activePage === 'balance-state')
                this.$root.$refs.dashboardBalanceState.getData()
            else if (this.activePage === 'budget-forecast-company')
                this.$root.$refs.dashboardBudgetForecastCompany.getData()
            else if (this.activePage === 'budget-forecast-client')
                this.$root.$refs.dashboardBudgetForecastClient.getData()
            else if (this.activePage === 'budget-forecast-activity')
                this.$root.$refs.dashboardBudgetForecastActivity.getData()
            else if (this.activePage === 'budget-rolling-company')
                this.$root.$refs.dashboardBudgetRollingCompany.getData()
            else if (this.activePage === 'budget-rolling-client')
                this.$root.$refs.dashboardBudgetRollingtClient.getData()
            else if (this.activePage === 'budget-rolling-activity')
                this.$root.$refs.dashboardBudgetRollingActivity.getData()
            else if (this.activePage === 'fees-interactive')
                this.$root.$refs.dashboardFeesInteractive.getData()
            else if (this.activePage === 'fees-pivot-firm')
                this.$root.$refs.dashboardFeesPivot.getData()
            else if (this.activePage === 'fees-pivot-client')
                this.$root.$refs.dashboardFeesPivot.getData()
            else if (this.activePage === 'evolution-interactive')
                this.$root.$refs.dashboardEvolutionInteractive.getData()
            else if (this.activePage === 'evolution-pivot')
                this.$root.$refs.dashboardEvolutionPivot.getData()
            else if (this.activePage === 'billed-vs-real-interactive')
                this.$root.$refs.dashboardBilledVsRealInteractive.getData()
            else if (this.activePage === 'billed-vs-real-pivot')
                this.$root.$refs.dashboardBilledVsRealPivot.getData()
            else if (this.activePage === 'billed-vs-real-filterable')
                this.$root.$refs.dashboardBilledVsRealFilterable.getData()
                // else if (this.activePage === 'legal-deadlines') this.$root.$children.$refs.pvagTable.getItems()
            // else if (this.activePage === 'legal-pv-generator') this.$root.$refs.pvGenerator.resetKey()
            else if (this.activePage === 'client-fees') {
                this.$root.$refs.clientTableFees.getData()
                this.$root.$refs.clientTableBudgets.getData()
            }
        },

        filterData(id) {
            if (this.pageName === 'pendingImported') {
                this.$root.$refs.pendingImportedTable.filterItems(id)
                this.$root.$refs.pendingImportedTable.updateCounters()
            } else if (this.pageName === 'pendingSent') {
                this.$root.$refs.pendingSentTable.filterItems(id)
                this.$root.$refs.pendingSentTable.updateCounters()
            } else if (this.pageName === 'pendingAnswered') {
                this.$root.$refs.pendingAnsweredTable.filterItems(id)
                this.$root.$refs.pendingAnsweredTable.updateCounters()
            } else if (this.pageName === 'pendingSolved') {
                this.$root.$refs.pendingSolvedTable.filterItems(id)
                this.$root.$refs.pendingSolvedTable.updateCounters()
            }
        }
    },

    computed: {
        ...mapState({
            activePage: (state) => state.browsing.pageName
        })
    }
}
</script>

<style scoped></style>
